import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { useProductCategory } from "../../../../../hooks/query";

export default function useCreateCategory() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { useCreate } = useProductCategory();
    const createCategorySvc = useCreate();

    async function handleCreateCategory(data: any) {
        try {
            await createCategorySvc.mutateAsync({
                Name: data.Name,
                Description: data.Description || undefined,
                DefaultUnitType: data.DefaultUnitType || undefined,
                MeasurementTypes: data.MeasurementTypes || undefined,
                IsActive: data.IsActive ?? true,
            });

            // Invalidate and refetch
            queryClient.invalidateQueries({ queryKey: ["product-categories"] });

            // Navigate to list
            navigate("/admin/product-category/list");
        } catch (error) {
            console.error("Failed to create product category:", error);
        }
    }

    return {
        handleCreateCategory,
        createCategorySvc,
    };
}
